import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../utils';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';

const PartnerCampaignStatusSchema = z
  .enum(['ACTIVE', 'INACTIVE'])
  .describe('PartnerCampaignStatusSchema');

export type PartnerCampaignStatus = z.infer<typeof PartnerCampaignStatusSchema>;

const UpdatePartnerCampaignStatusRequestParamsSchema = z
  .object({
    campaignId: z.union([z.string(), z.number()]),
  })
  .describe('UpdatePartnerCampaignStatusRequestParamsSchema');

const UpdatePartnerCampaignStatusRequestBodySchema = z
  .object({
    brandId: z.string(),
    status: PartnerCampaignStatusSchema,
  })
  .describe('UpdatePartnerCampaignStatusRequestBodySchema');

const UpdatePartnerCampaignStatusRequestSchema = z.object({
  params: UpdatePartnerCampaignStatusRequestParamsSchema,
  body: UpdatePartnerCampaignStatusRequestBodySchema,
});

export type UpdatePartnerCampaignStatusRequest = z.infer<
  typeof UpdatePartnerCampaignStatusRequestSchema
>;

const UpdatePartnerCampaignStatusResponseSchema = createApiResponseSchema(z.unknown());

export type UpdatePartnerCampaignStatusResponse = z.infer<
  typeof UpdatePartnerCampaignStatusResponseSchema
>;

/** PUT `/v1/partner/campaigns/{campaignId}/status` — 캠페인 활성화 여부 변경 */
export const updatePartnerCampaignStatus = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(UpdatePartnerCampaignStatusRequestSchema),
    async (request: UpdatePartnerCampaignStatusRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.put<UpdatePartnerCampaignStatusResponse>(
          partnerApiPath.updateCampaignStatus(request.params.campaignId),
          request.body,
        ),
      ),
    validateApiResponse(UpdatePartnerCampaignStatusResponseSchema),
  ),
);
